export const FEEDBACK_SENTIMENTS = ["poor", "okay", "good", "great"] as const;
export const FEEDBACK_TYPES = ["problem", "idea", "general"] as const;
export const FEEDBACK_STATUSES = ["new", "reviewed", "planned", "resolved", "dismissed"] as const;
export const FEEDBACK_CONTEXTS = ["anonymous", "customer", "business", "admin"] as const;

export const CUSTOMER_FEEDBACK_CATEGORIES = [
  ["search", "Finding products / Search"],
  ["listings", "Products / Listings"],
  ["businesses", "Local businesses"],
  ["checkout", "Checkout"],
  ["orders_pickup", "Orders / Pickup"],
  ["messages", "Messages"],
  ["returns_refunds", "Returns / Refunds"],
  ["account", "Account"],
  ["other", "Other"],
] as const;

export const BUSINESS_FEEDBACK_CATEGORIES = [
  ["dashboard", "Dashboard"],
  ["listings", "Listings"],
  ["inventory", "Inventory"],
  ["orders", "Orders"],
  ["pos", "POS"],
  ["payments", "Payments"],
  ["returns_refunds", "Returns / Refunds"],
  ["messages", "Messages"],
  ["account_settings", "Account / Settings"],
  ["other", "Other"],
] as const;

const BUSINESS_FEEDBACK_CATEGORIES_WITHOUT_POS = BUSINESS_FEEDBACK_CATEGORIES.filter(
  ([value]) => value !== "pos"
);

export const FEEDBACK_CATEGORIES = Array.from(new Set([
  ...CUSTOMER_FEEDBACK_CATEGORIES.map(([value]) => value),
  ...BUSINESS_FEEDBACK_CATEGORIES.map(([value]) => value),
])) as string[];

export const FEEDBACK_COMMENT_MAX_LENGTH = 1500;
export const CHECKOUT_FEEDBACK_REASONS = ["confusing", "too_slow", "payment_issue", "pickup_info_unclear", "other"] as const;

export type FeedbackSentiment = (typeof FEEDBACK_SENTIMENTS)[number];
export type FeedbackType = (typeof FEEDBACK_TYPES)[number];
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];
export type FeedbackContext = (typeof FEEDBACK_CONTEXTS)[number];

export function getFeedbackCategories(
  context: FeedbackContext,
  { canAccessPos = false }: { canAccessPos?: boolean } = {}
) {
  if (context !== "business") return CUSTOMER_FEEDBACK_CATEGORIES;
  return canAccessPos
    ? BUSINESS_FEEDBACK_CATEGORIES
    : BUSINESS_FEEDBACK_CATEGORIES_WITHOUT_POS;
}

export function feedbackCategoryLabel(value: string) {
  return [...CUSTOMER_FEEDBACK_CATEGORIES, ...BUSINESS_FEEDBACK_CATEGORIES]
    .find(([key]) => key === value)?.[1] || value.replaceAll("_", " ");
}

export function feedbackTypeLabel(value: string) {
  return value === "problem" ? "Problem / negative" : value === "general" ? "Positive / general" : value === "idea" ? "Idea" : value;
}

export function inferFeedbackPageContext(pathname: string) {
  if (/^\/business(?:\/|$)/.test(pathname)) return "business";
  if (/^\/checkout(?:\/|$)/.test(pathname)) return "checkout";
  if (/^\/(?:account\/)?orders(?:\/|$)/.test(pathname)) return "order";
  if (/^\/messages(?:\/|$)/.test(pathname)) return "messages";
  if (/^\/support(?:\/|$)/.test(pathname)) return "support";
  if (/^\/listings\//.test(pathname)) return "listing";
  if (pathname === "/" || pathname === "/customer/home") return "home";
  return "page";
}
